import { convert, ConvertUnits, MeasurementSystem } from "../units/units";
import {
  formatMeasurement,
  FormattedMeasurement,
} from "portal/components/measurement/formatters";
import { i18n as I18n, TFunction } from "i18next";

export const radiusPixelsToDiameterUnits = (
  radiusPixels: number,
  ppcm: number,
  units: ConvertUnits
): number => {
  const diameterPixels = radiusPixels * 2;
  if (ppcm === 0) {
    throw new Error("Cannot divide by zero.");
  }
  const diameterCm = diameterPixels / ppcm;
  return convert(diameterCm).from("cm").to(units);
};

export const diameterUnitsToRadiusPixels = (
  diameterUnits: number,
  ppcm: number,
  units: ConvertUnits
): number => {
  const diameterCm = convert(diameterUnits).from(units).to("cm");
  const diameterPixels = diameterCm * ppcm;
  return diameterPixels / 2;
};

/** Convert a user-facing radius (mm/in) to radius in mm for Veselka filters. */
export const radiusUnitsToMm = (
  radiusUnits: number,
  units: ConvertUnits
): number => convert(radiusUnits).from(units).to("mm");

// users want to consistently see 'mm' or 'in'
export const getRadiusFilterUnits = (
  measurementSystem: MeasurementSystem
): ConvertUnits =>
  measurementSystem === MeasurementSystem.imperial ? "in" : "mm";

export const formatRadius = (
  t: TFunction,
  i18n: I18n,
  measurementSystem: MeasurementSystem,
  radiusCm: number
): FormattedMeasurement =>
  formatMeasurement(t, i18n, measurementSystem, radiusCm, "cm", {
    decimalPlaces: 2,
    toUnits: getRadiusFilterUnits(measurementSystem),
  });
